export const BASE_CLASS_NAME = `group min-h-[42px] relative flex items-center justify-center gap-2 rounded-lg py-2.5 font-medium text-sm main-transition-colors outline-none focus-visible:ring-2 ring-offset-1 whitespace-nowrap [&>*]:font-semibold font-semibold`

export const DASHBOARD_FONT_CLASS_NAME =
  '[&>*]:font-semibold font-semibold [&>*]:font-inter font-inter'

export const PUBLIC_FONT_CLASS_NAME = '[&>*]:font-mulish font-mulish'
